import { create } from 'zustand';

// Phase 0 placeholder for the paragraph-selection invariant (05 §D-012).
interface SelectionState {
  paragraphId: string | null;
  select: (id: string | null) => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  paragraphId: null,
  select: (id) => set({ paragraphId: id }),
}));
